import React from 'react';
import { CasePlanDetailCard, CasePlanDetailCardSkeleton } from '@orijinworks/frontend-commons';

export function CasePlanDetailHeader({ cardProps, isSectionsLoading, onBack, onEditorsClick, onExportClick }) {
  if (cardProps) {
    return (
      <CasePlanDetailCard
        {...cardProps}
        onBackClick={onBack}
        onEditorsClick={onEditorsClick}
        onExportClick={onExportClick}
      />
    );
  }

  if (isSectionsLoading) {
    return <CasePlanDetailCardSkeleton showBackButton />;
  }

  return null;
}
